<template>
  <ViceAvatar :name="name" :image="profile_photo_url" v-if="showImage" class="w-24 h-24 text-2xl" />
  <p v-else class="flex flex-col items-center text-gray-200 text-center font-bold">
    <EyeOffIcon class="w-12 h-12 mb-2 text-vice-dark-grey text-sm" />
    {{ displayText }}
  </p>
</template>

<script>
import { EyeOffIcon } from '@heroicons/vue/outline';
import ViceAvatar from '@/Components/Avatars/ViceAvatar.vue';

export default {
  props: {
    name: {
      type: String,
    },
    profile_photo_url: {
      type: String,
    },
    showImage: {
      type: Boolean,
      default: true,
    },
    displayText: {
      type: String,
      default: '',
    },
  },
  components: {
    ViceAvatar,
    EyeOffIcon,
  },
};
</script>
